module.exports = __webpack_public_path__ + "static/media/image-01.b3e517d6.jpg";